import { UI_LANGUAGES, type UiLanguageCode } from './ui-languages';

const UI_LANG_CODE_SET = new Set<string>(UI_LANGUAGES.map((l) => l.code));

export function normalizeInstitutionCategoryUiLang(i18nLang: string | undefined): UiLanguageCode {
  const base = (i18nLang ?? 'fr').split('-')[0].toLowerCase();
  if (UI_LANG_CODE_SET.has(base)) return base as UiLanguageCode;
  return 'fr';
}

function asTranslationRecord(raw: unknown): Record<string, string> | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
  return raw as Record<string, string>;
}

export type InstitutionCategoryI18nSource = {
  name: string;
  nameTranslations?: unknown;
  description?: string | null;
  descriptionTranslations?: unknown;
};

export function localizedInstitutionCategoryName(
  cat: InstitutionCategoryI18nSource,
  i18nLang: string | undefined,
): string {
  const lang = normalizeInstitutionCategoryUiLang(i18nLang);
  const tr = asTranslationRecord(cat.nameTranslations);
  const v = tr?.[lang]?.trim();
  if (v) return v;
  return cat.name ?? '';
}

export function localizedInstitutionCategoryDescription(
  cat: InstitutionCategoryI18nSource,
  i18nLang: string | undefined,
): string {
  const lang = normalizeInstitutionCategoryUiLang(i18nLang);
  const tr = asTranslationRecord(cat.descriptionTranslations);
  const v = tr?.[lang]?.trim();
  if (v) return v;
  return (cat.description ?? '').trim();
}
